import React, { useEffect, useState, FC } from "react";
import { Button, Form, message, Modal, Tooltip, Upload } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { usePurchaseApprovalDetailsModel } from "./purchaseApprovalDetailsModel";
import { globalPrompt } from "@/components/message";
import { ITopType, ITreeSelectData } from "@/types/ScmTypes";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { DetailType } from "@/types/ScmEnums";
import { usePurchaseApprovalModel } from "../../purchaseApprovalModel";
import { debounce } from "lodash";
import FontIcon from "@/components/YhIcon";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import { UploadOutlined } from "@ant-design/icons";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { fileDownload } from "@/utils/exportFile";
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";
import { useOrgModel } from "@/views/organization/org/orgModel";
import { purchaseApprovalService } from "../../purchaseApprovalService";
import moment from "moment";

export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const {
        detailEditForm,
        detailAddForm,
        detailLookForm,
        detailAddList,
        detailDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setTopButsControl,
        setSupplierHistoryModel,
        setSupplierHistoryVisible,
        saveLoading, setSaveLoading,
        Submit, onTranfer,
        Transfer, topButsControl
    } = usePurchaseApprovalDetailsModel();
    const {
        setSelectedRowKeys,
        setSelectedRow,
        setDescRows,
    } = usePurchaseApprovalModel()
    const { getTreeNodeName } = useDictModel();
    const { treeSource, getOrgTreeSelect } = useOrgModel();
    const { allShopDs, beShopDs, supplieAllList, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType } } = useGlobalModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { getSelectedDictOne } = useDictModel();

    // 判断是否为剩余审批模式
    const isRemainingApproval = mode === DetailType.add && parentInfo?.remainingApprovalData;
    const remainingApprovalData = parentInfo?.remainingApprovalData || {};

    const typeForm: any = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
        // 处理剩余审批数据初始化
        if (isRemainingApproval && Object.keys(remainingApprovalData).length > 0) {
            const formData = { ...remainingApprovalData };
            setDetailAddForm(formData);

            // 如果原数据有详情列表，则复制到新增列表中
            if (remainingApprovalData.details && remainingApprovalData.details.length > 0) {
                const newDetails = remainingApprovalData.details.filter((item: any) => !item.planCode && item.deleteFlag !== 1).map((item: any) => {
                    return {
                        brandCode: item.brandCode,
                        brandName: item.brandName,
                        chassisBrand: item.chassisBrand,
                        confirmNum: item.confirmNum,
                        id: '',
                        initNum: item.initNum,
                        materialCode: item.materialCode,
                        materialName: item.materialName,
                        model: item.model,
                        note: item.note,
                        purpose: item.purpose,
                        unitCode: item.unitCode,
                        unitName: item.unitName,
                        upperClothBrand: item.upperClothBrand,
                        vehicleModel: item.vehicleModel,
                    };
                });
                setDetailAddList(newDetails);
            }
        }
    }, [id, mode,])
    useEffect(() => {
        return () => {
            !findNav("11-5-1") && resetAddCatch(mode);
            !findNav("11-5-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])


    const save = () => {
        let goods = mode === "add" ? detailAddList : detailDataSource
        let purcharseNum = goods.filter(item => item.confirmNum == 0)
        if (purcharseNum.length > 0) {
            globalPrompt("message", { text: `【${purcharseNum.map(item => item.materialName).join()}】的确认数量不能为0`, type: "error" })
            return
        }
        IFormRef.current?.validateFields().then(async res => {
            const { fileList = [], ...val } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    console.log(file)
                    return message.error('文件信息有误，请重新上传文件')
                }
                val.md5 = file?.uid
                val.fileName = file?.name
            }
            else {
                val.md5 = ''
                val.fileName = ''
            }
            if (mode === "add") {
                const resData = await insertDetail(val)
                if (resData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    resetAddCatch(mode);
                    goBack();
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
            } else if (mode === "edit") {
                let { id, approvalCode } = detailEditForm
                const resData = await editDetail({ ...detailEditForm, ...val, id, approvalCode })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    getDetailEditOne(id as string, mode)
                }
            }
        })
    }
    const goBack = () => {
        replaceNav(selectedNavId, "11-5")
    }
    const onRefresh = async () => {
        if (mode === 'add') {
            IFormRef.current?.resetFields()
            setDetailAddForm({})
            setDetailAddList([])

        } else if (mode === 'edit') {
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }
    const onSubmit = async () => {
        globalPrompt("modal", {
            title: "审批审核",
            type: "warning",
            text: `您正在提报审批此条单据，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                let ret = await Submit()
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "审批单提报成功", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "审批单提报失败", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )

    }
    const onTranferPlan = async () => {
        globalPrompt("modal", {
            title: "转采购订单",
            type: "warning",
            text: `您正在将此单据转采购订单，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                let ret = await onTranfer()
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": ret, "type": "success" });
                } else {
                    globalPrompt("message", { "text": ret, "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )

    }
    const onTrunPo = async (value: any, message: any) => {
        globalPrompt("modal", {
            title: "审批审核",
            type: "warning",
            text: `您正在审批此条单据'${message}'，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                let ret = await Transfer(value)
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "审核成功", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "审核失败", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )
    }
    const returnApproval = async (id: any) => {
        globalPrompt("modal", {
            title: "重新询价",
            type: "warning",
            text: `您正在重新询价此条单据，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                let ret = await purchaseApprovalService.returnApproval(id)
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "重新询价成功！", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "重新询价失败！", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )
    }
    const rightChildren = <>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_RETURNAPPROVAL}>
            {(mode == "edit" && typeForm[mode].status === "purchase_approval.audited") && <>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={topButsControl}
                    onClick={debounce(() => { returnApproval(typeForm[mode].id) }, 900)}
                >重新询价</Button>
            </>
            }
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_SUBMIT}>
            {(mode == "edit" && typeForm[mode].status === "purchase_approval.init") && <>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={topButsControl}
                    onClick={debounce(() => { onSubmit() }, 900)}
                >提交</Button>
            </>
            }
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_APPROVAL}>
            {(mode == "edit" && typeForm[mode].status === "purchase_approval.submit") && <>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={topButsControl}
                    onClick={debounce(() => { onTrunPo('purchase_approval.audited', '审批通过') }, 900)}
                >审批通过</Button>
            </>
            }
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_APPROVAL}>
            {(mode == "edit" && typeForm[mode].status === "purchase_approval.submit") && <>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    danger
                    disabled={topButsControl}
                    onClick={debounce(() => { onTrunPo('purchase_approval.reject', '审批驳回') }, 900)}
                >审批驳回</Button>
            </>
            }
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_SAVE}>
            {(mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) &&
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            }
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_TRANSFER}>
            {(mode == "edit" && typeForm[mode].status === "purchase_approval.audited") && <>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={topButsControl}
                    onClick={debounce(() => { onTranferPlan() }, 900)}
                >转采购订单</Button>
            </>
            }
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_BACK}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={goBack}
            >返回</Button>
        </YhAuth>
    </>;

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    //采购类型
    const purchaseTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ purchaseTypeName: option.label, purchaseTypeCode: option.value, customerCode: '', customerName: '' });
    }
    const customerCodeChange = (value: string, option: ISelectOption) => {
        option && onChange({ customerCode: option.label, customerName: option.value });
    }
    //所属站点
    const shopNameChange = (value: string, option: ISelectOption) => {
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }
    //审批类型
    const approveTypeCodeChange = (value: string, option: ISelectOption) => {
        option && onChange({ approveTypeCode: option.value, approveTypeName: option.label });
    }
    //机构选中
    const onTreeSelectChange = (value: string, node: ITreeSelectData) => {
        node && onChange({ orgCode: node.value, orgName: node.title });
    }
    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "填报人",
                fieldName: "createUser",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            }, {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "填报部门",
                fieldName: "orgCode",
                treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                onTreeSelectChange,
                rules: [{
                    required: true,
                    message: "关联机构不能为空"
                }],
                disable: typeForm[mode].oldCode, // 剩余审批模式下不可编辑
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "填报日期",
                fieldName: "createTimes",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审批人",
                fieldName: "approver",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审批时间",
                fieldName: "approvalTimes",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: (shopType === 0 && mode == 'add' ? false : true) || typeForm[mode].oldCode // 剩余审批模式下不可编辑
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "对接人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }],
                disable: typeForm[mode].oldCode // 剩余审批模式下不可编辑
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }],
                disable: typeForm[mode].oldCode // 剩余审批模式下不可编辑
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "审批类型",
                fieldName: "approveTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.APPROVAL_TYPE),
                showSearch: false,
                onSelectChange: approveTypeCodeChange,
                rules: [{ required: true, message: "请选择审批类型" }],
                disable: typeForm[mode].oldCode // 剩余审批模式下不可编辑
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "approveTypeName",
                fieldName: "approveTypeName",
                hidden: true
            },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "是否直发",
            //     fieldName: "isDirect",
            //     allowClear: true,
            //     showSearch: true,
            //     options: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
            //     rules: [{ required: true, message: "请选择是否直发" }],
            //     // span: 5,
            //     // labelCol: { offset: 1 },
            // },
            {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "采购类型",
                fieldName: "purchaseTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.PURCHASE_TEPE),
                onSelectChange: purchaseTypeChange,
                rules: [{ required: true, message: "请选择采购类型" }],
                disable: typeForm[mode].oldCode // 剩余审批模式下不可编辑
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购类型名称",
                fieldName: "purchaseTypeName",
                hidden: true
            },
            ...((str) => {
                if (str) {
                    return [
                        {
                            type: FormItemTypeEnum.Select,
                            fieldLabel: "客户名称",
                            fieldName: "customerCode",
                            options: transOptions(CustomerData),
                            allowClear: true,
                            showSearch: true,
                            onSelectChange: customerCodeChange,
                            rules: [{ required: true, message: "请选择客户名称" }],
                            disable: typeForm[mode].oldCode // 剩余审批模式下不可编辑
                        },
                        {
                            type: FormItemTypeEnum.Input,
                            fieldLabel: "采购类型名称",
                            fieldName: "customerName",
                            hidden: true
                        }
                    ]
                } else {
                    return []
                }
            })(typeForm[mode].purchaseTypeCode == 'purchase-type.c'),
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",// 剩余审批模式下不可编辑
            },
            // 添加oldCode字段
            ...(typeForm[mode].oldCode ? [{
                type: FormItemTypeEnum.Input,
                fieldLabel: "原单号",
                fieldName: "oldCode",
                disable: true,
                placeholder: "自动生成"
            }] : []),
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "填报部门",
                fieldName: "orgName",
                hidden: true
            },

            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 16,
                hidden: mode == 'look' && !detailLookForm.md5 ? true : false,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file: any) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )

                            }}
                        >
                            {mode !== 'look' &&
                                <>
                                    <Button icon={<UploadOutlined />} >选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>}
                        </Upload>
                    </Form.Item>
                ),
            },
        ]
    };



    const onChange = (changedValues: { [key: string]: any }) => {
        let newChangedValues = changedValues;
        mode === "add" ? updateAddFormVal(newChangedValues) : updatEditFormVal(newChangedValues);
        setTopButsControl(true)
    }


    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode === DetailType.look,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }



    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        审批单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].code ?? "暂无"}</span>
                        单据状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: 'red' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}